import 'react';
import 'prop-types';
import clsx from 'clsx';
import { Label, Glyphicon, Text } from 'reaxl';
import { BrowserStorage } from '@atc/browser-storage';
import formatDateToMMDD from '../utilities/formatDateToMMDD.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const lastSyncCache = /* #__PURE__*/new BrowserStorage('LAST_WALLET_SYNC', {
  persist: true
});
function SyncMyWalletAlert() {
  let {
    success,
    className,
    uiContext = 'default'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (uiContext === 'default') {
    return /*#__PURE__*/jsxs(Label, {
      "data-cmp": "wallet-sync-alert",
      className: clsx('margin-bottom-0 display-inline-flex align-items-baseline', className),
      bsStyle: success ? 'secondary' : 'danger',
      children: [/*#__PURE__*/jsx(Glyphicon, {
        glyph: success ? 'success' : 'danger',
        className: clsx('margin-right-2', success && 'text-success')
      }), success ? 'Settings Updated!' : 'Import Unsuccessful. Try Again.']
    });
  }
  const lastDateSync = lastSyncCache.getItem();
  const syncDate = lastDateSync ? new Date(lastDateSync) : new Date();
  const formattedDate = formatDateToMMDD(syncDate);
  return /*#__PURE__*/jsx(Text, {
    color: `${success ? 'success' : 'danger'}`,
    componentClass: "div",
    size: 200,
    children: success ? `Synced ${formattedDate}` : 'Import Unsuccessful. Try Again.'
  });
}
export { SyncMyWalletAlert as default };
